import { render, staticRenderFns } from "./BulletinList.vue?vue&type=template&id=c930c75e&"
import script from "./BulletinList.vue?vue&type=script&lang=js&"
export * from "./BulletinList.vue?vue&type=script&lang=js&"
import style0 from "./BulletinList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports